<template>
  <div>
    <PageTitleVue
      :sub-title="'Altere os dados cadastrais desse aluno'"
    >
      Atualizar dados

      <template #b-action>
        <Create
          @click="router.back()"
          :icon="PhArrowLeft"
          :label="'Voltar'"
          :menu-active="'Lutadores'"
        />
      </template>
    </PageTitleVue>

    <Form
      id="form-fields"
      :descriptionTitle="'Dados pessoais'"
      :isCreate="false"
    >
      <!-- <ShiftForm
        :descriptionTitle="'Gestão dos eventos'"
        :descriptionSubTitle="'Gerencie todos os eventos desse lutador'"
      /> -->

      <!-- <CacheForm
        :descriptionTitle="'Turmas'"
        :descriptionSubTitle="'Todas as turmas que esse aluno participa'"
      /> -->

      <Password
        :create="false"
        :descriptionTitle="'Senha de acesso'"
        :descriptionSubTitle="'Altere a senha de acesso do aluno'"
      />

      <div class="w-full flex justify-center mt-4">
        <CreateButton
          @click="updateCollaborator"
          :icon="'fa-solid fa-user-plus'"
          :label="'Atualizar'"
        />
      </div>
    </Form>

    <!-- <FloatBackPage /> -->
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import CollabService from '../services/collab.service'
import Create from '@/components/Buttons/Create.vue'
import Password from './PasswordForm.vue'
import Form from './Form.vue'
import * as yup from '@/validator'
import router from '@/router'
import { dataFighters } from '../store'
import { storeApp } from '@/store'
import { setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { onBeforeMount, onMounted, computed } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { useRoute } from 'vue-router'
import { PhArrowLeft } from '@phosphor-icons/vue'

import ShiftForm from './ShiftForm.vue'
import moment from 'moment'
import CacheForm from './CacheForm.vue'

const fighter_id = useRoute().params.id
const appStore = storeApp
const store = dataFighters
const coupons = computed(() => dataFighters.getters.getMyEvents) // eventos do lutador

const form = yup.object().shape({
  name: yup.string().required().label('Nome').min(3).max(100),
  phone: yup.string().nullable().label('Celular').max(20),
  email: yup.string().required().label('Email').max(100),
  percent: yup.number().label('Porcentagem').min(1).max(99).nullable()
})

const password = yup.object().shape({
  password: yup.object().shape({
    old: yup.string().min(5, 'Inválido').required('Por favor informe a senha anterior'),
    newPass: yup.string().required('É necessário informar a nova senha').min(5, 'Deve ter no mínimo 5 caracteres'),
    confirm: yup.string().oneOf([yup.ref('newPass'), null], 'As senhas devem ser iguais').required('Por favor confirme a nova senha')
  })
})

onBeforeMount(async () => {
  store.commit('reset')
  appStore.state.loading = true
  await getFighterBy()
  appStore.state.loading = false
})

async function getFighterBy () {
  store.commit('reset')
  await CollabService.getFightersById(fighter_id)
    .then(res => {
      store.commit('updateCollabFields', res.data)
      mountItems()
    }).catch(err => {
      console.log(err)

      toast(
        'Erro',
        'Algo deu arrado ao buscar dados do colaborador',
        'error'
      )
    })
}

function mountItems () {
  const filteredEvents = coupons.value
    ?.map(c => ({
      title: c.event?.title,
      coupon_id: c.event?.id,
      starts_at: c.event?.starts_at
    }))
    ?.filter(event => {
      return moment(event?.starts_at).isSameOrAfter(moment(), 'day')
    })

  dataFighters.commit('SET_MY_EVENTS', filteredEvents)
}

async function updateCollaborator () {
  // validação dos campos de login
  if (store.state.password.newPass) {
    const validatePassword = (
      await validateFormField(password, store.state)
    )

    if (validatePassword && validatePassword.length > 0) {
      setFormFieldsError(validatePassword)
      appStore.state.loading = false
      return
    }
  }

  const data = Object.assign({}, store.state)

  delete data.myEvents
  delete data.fighters
  delete data.events
  delete data.nextAndAllEvents
  delete data.google_id
  delete data.avatar
  delete data.created_at
  delete data.updated_at
  // delete data.is_fighter
  delete data.deleted_at
  delete data.coupon
  delete data.page

  data.password = data.password.newPass

  appStore.state.loading = true

  const validate = (
    await validateFormField(form, store.state)
  )

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.state.loading = false
    return
  }

  if ( // se caso exista uma foto, remova e troque pela nova
    store.state.image &&
    typeof store.state.image === 'object' &&
    typeof store.state.imgPath === 'string' &&
    store.state.imgPath !== '[]'
  ) {
    await CollabService.saveImage(store.state.image)
      .then((res) => {
        data.imgPath = res.data
        data.image = process.env.VUE_APP_IMAGE_SERVE + 'storage/' + res.data
      })
      .catch((err) => {
        toast(
          'Aviso',
          'Algo deu errado ao subir arquivo!',
          'error'
        )
      })
  } else if ( // adicione uma nova foto
    store.state.image &&
    typeof store.state.image !== 'string'
  ) {
    await CollabService.saveImage(store.state.image)
      .then((res) => {
        data.imgPath = res.data
        data.image = process.env.VUE_APP_IMAGE_SERVE + 'storage/' + res.data
      })
      .catch((err) => {
        toast(
          'Aviso',
          'Algo deu errado ao subir arquivo!',
          'error'
        )
      })
  } else { // passa o caminho da imagem
    // store.state.image = store.state.imgPath
    data.image = store.state.imgPath
  }

  delete data.imgPath

  await CollabService.editFighter(data)
    .then(res => {
      appStore.state.loading = false
      if (res.data.success) {
        toast(
          'Sucesso',
          res.data.message,
          'success'
        )
      }
    })
    .catch(err => {
      appStore.state.loading = false

      toast(
        'Erro',
        err.response.data.message,
        'error'
      )
    })
}

</script>

<style lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
